import { COUNTRIES } from '../constants/action-types';
import { sortArrayByProperty } from '../../scripts/utilities/helpers';
import asyncActionTypes from '../actions/types.js';

const initialState = {
  countries: false,
  countryContent: [],
  loading: false,
  errorCountries: null,
};

const countries = (state = initialState, action) => {
  switch (action.type) {
    case COUNTRIES:
      if ( state.countries === false ) {
        return { ...state, countries: [...state.countries, action.payload.countries] };
      }
      break;

    case asyncActionTypes.RETRIEVE_CMS_COUNTRIES.START:
      return {
        ...state,
        loading: true,
        countryContent: [],
        errorCountries: null,
      };
    case asyncActionTypes.RETRIEVE_CMS_COUNTRIES.SUCCESS:
      /*
      El objeto esperado debe ser:
      [{
        code: "93"
        name: "Afganistán"
        value: "AF"
      },...]
      */

      const contriesArray = action.payload.countries.map(countryListItem => countryListItem.country).filter(country => {
        return country.cca2 && country.telephoneCode;
      }).map(country => {
        return {
          code: country.telephoneCode,
          name: country.copy,
          value: country.cca2,
        };
      });

      return {
        ...state,
        loading: false,
        countryContent: sortArrayByProperty(contriesArray, 'name'),
        errorCountries: null,
      };

    case asyncActionTypes.RETRIEVE_CMS_COUNTRIES.FAIL:
      return {
        ...state,
        loading: false,
        errorCountries: action.error,
      };

    default:
      return state;
  }
  return initialState;
};

export default countries;
